import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames/bind';
import InputField from '../inputField';
import styles from './styles.scss';
const cx = classnames.bind(styles);
class BasePasswordField extends Component {
    static propTypes = {
        className: PropTypes.string,
        elmId: PropTypes.string.isRequired,
    };
    static defaultProps = {
        className: '',
        elmId: 'base_password_field',
    };
    state = { show: false };
    onToggle = () => this.setState({ show: !this.state.show });
    render() {
        const { show } = this.state;
        const { elmId, className, ...inputProps } = this.props;
        return (_jsxs(InputField, { ...inputProps, elmId: elmId, className: `password ${cx('root', className)}`, type: show ? 'text' : 'password', children: [_jsx("input", {}), _jsx("span", { "data-elm-id": `${elmId}_toggle`, className: cx('toggle'), onClick: this.onToggle, children: show ? 'Hide' : 'Show' })] }));
    }
}
export default BasePasswordField;
//# sourceMappingURL=index.js.map